import { faList } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { FC } from 'react'
import React from 'react'
import styled from 'styled-components'

import Card from '@/components/Card'
import H5 from '@/components/H5'
import type { BespokeCriteriaReferenceGroup } from '@/utils/bespoke-criteria'
import { bespokeCriteriaConfigs } from '@/utils/bespoke-criteria'

const Container = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`

const IconWrapper = styled.span`
  margin-right: 10px;
`

const UL = styled.ul`
  margin: 0;
  margin-top: 20px;
  padding-left: 30px;
`

const LI = styled.li`
  margin-top: 15px;
`

interface Props {
  referenceGroup: BespokeCriteriaReferenceGroup
}

const BespokeCriteriaCard: FC<Props> = ({ referenceGroup }) => (
  <Card>
    <Container>
      <H5>
        <IconWrapper>
          <FontAwesomeIcon size="1x" icon={faList} />
        </IconWrapper>{' '}
        Special criteria
      </H5>
      <UL>
        {bespokeCriteriaConfigs
          .filter(({ referenceGroup: group }) => group === referenceGroup)
          .map(({ criteria }) => criteria.map((c, i) => <LI key={i}>{c}</LI>))}
      </UL>
    </Container>
  </Card>
)

export default BespokeCriteriaCard
